var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center error-body",staticStyle:{"margin-top":"18%"}},[_c('img',{attrs:{"src":"//cdn.eduzhixin.com/cdn/web/static/img/404.c085271.png"}}),_vm._v(" "),_c('h3',[_c('a',{staticStyle:{"font-size":"18px","color":"#979dac","margin-top":"20px"},attrs:{"href":"/"}},[_vm._v("当前页面似乎受到三体射线的干扰，点此返回首页")])])])
}]

export { render, staticRenderFns }